module.exports = __webpack_public_path__ + "img/start1.f2eef77b.jpg";